export default __webpack_public_path__ + "static/media/healthcare-services-table.57ce47d4.jpeg";